import {
  GET_USERS,
  GET_USERS_FAIL,
  GET_USERS_SUCCESS,
  ADD_NEW_USER,
  ADD_USER_SUCCESS,
  ADD_USER_FAIL,
  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_FAIL,
  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_FAIL,
  GET_ACCOUNT,
  GET_ACCOUNT_SUCCESS,
  GET_ACCOUNT_ERROR,
  RESEND_USER_INVITE,
  RESEND_USER_INVITE_SUCCESS,
  RESEND_USER_INVITE_ERROR,
  RESET_USER_INVITE_SENT_TO,
  GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_ERROR,
  GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS,
  GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_SUCCESS,
  GET_CAMPAIGN_SPENDS,
  GET_CAMPAIGN_SPENDS_SUCCESS,
  GET_CAMPAIGN_SPENDS_ERROR,
  GET_CAMPAIGNS_BY_ACCOUNT,
  GET_CAMPAIGNS_BY_ACCOUNT_SUCCESS,
  GET_CAMPAIGNS_BY_ACCOUNT_ERROR,
  GET_AD_GROUPS_BY_CAMPAIGN,
  GET_AD_GROUPS_BY_CAMPAIGN_SUCCESS,
  GET_AD_GROUPS_BY_CAMPAIGN_ERROR,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_SUCCESS,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_ERROR,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_SUCCESS,
  GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_ERROR,
  GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS,
  GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_SUCCESS,
  GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_ERROR
} from "./actionTypes"

export const getUsers = () => ({
  type: GET_USERS,
})

export const getUsersSuccess = users => ({
  type: GET_USERS_SUCCESS,
  payload: { users },
})

export const addNewUser = user => ({
  type: ADD_NEW_USER,
  payload: user,
})

export const addUserSuccess = user => ({
  type: ADD_USER_SUCCESS,
  payload: user,
})

export const addUserFail = error => ({
  type: ADD_USER_FAIL,
  payload: error,
})

export const getUsersFail = error => ({
  type: GET_USERS_FAIL,
  payload: error,
})

export const updateUser = user => ({
  type: UPDATE_USER,
  payload: user
})

export const updateUserSuccess = user => ({
  type: UPDATE_USER_SUCCESS,
  payload: { user },
})

export const updateUserFail = error => ({
  type: UPDATE_USER_FAIL,
  payload: error,
})

export const deleteUser = email => ({
  type: DELETE_USER,
  payload: email,
})

export const deleteUserSuccess = user => ({
  type: DELETE_USER_SUCCESS,
  payload: { user },
})

export const deleteUserFail = error => ({
  type: DELETE_USER_FAIL,
  payload: error,
})

export const getAccount = () => ({
  type: GET_ACCOUNT
})

export const getAccountSuccess = (account) => ({
  type: GET_ACCOUNT_SUCCESS,
  payload: account
})

export const getAccountError = (error) => ({
  type: GET_ACCOUNT_ERROR,
  payload: error
})

export const resendUserInvite = (user) => ({
  type: RESEND_USER_INVITE,
  payload: user
})

export const resendUserInviteSuccess = (payload) => ({
  type: RESEND_USER_INVITE_SUCCESS,
  payload: payload
})

export const resendUserInviteError = (error) => ({
  type: RESEND_USER_INVITE_ERROR,
  payload: error
})

export const resetUserInviteSentTo = () => ({
  type: RESET_USER_INVITE_SENT_TO
})

export const getAdminManageClientAccountWithBrands = () => ({
  type: GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS,
})

export const getAdminManageClientAccountWithBrandsSuccess = accouts => ({
  type: GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_SUCCESS,
  payload: accouts,
})

export const getAdminManageClientAccountWithBrandsError = error => ({
  type: GET_ADMIN_MANAGE_CLIENT_ACCOUNT_WITH_BRANDS_ERROR,
  payload: error,
})

export const getCampaignSpends = (payload) => ({
  type: GET_CAMPAIGN_SPENDS,
  payload: payload
})

export const getCampaignSpendsSuccess = (response) => ({
  type: GET_CAMPAIGN_SPENDS_SUCCESS,
  payload: response
})

export const getCampaignSpendsError = (error) => ({
  type: GET_CAMPAIGN_SPENDS_ERROR,
  payload: error
})

export const getCampaignsByAccount = (payload) => ({
  type: GET_CAMPAIGNS_BY_ACCOUNT,
  payload: payload
})

export const getCampaignsByAccountSuccess = (payload) => ({
  type: GET_CAMPAIGNS_BY_ACCOUNT_SUCCESS,
  payload: payload
})

export const getCampaignsByAccountError = (error) => ({
  type: GET_CAMPAIGNS_BY_ACCOUNT_ERROR,
  error: error
})

export const getAdGroupsByCampaign = (payload) => ({
  type: GET_AD_GROUPS_BY_CAMPAIGN,
  payload: payload
})

export const getAdGroupsByCampaignSuccess = (payload) => ({
  type: GET_AD_GROUPS_BY_CAMPAIGN_SUCCESS,
  payload: payload
})

export const getAdGroupsByCampaignError = (error) => ({
  type: GET_AD_GROUPS_BY_CAMPAIGN_ERROR,
  error: error
})

export const getAdminManageClientSourceTypes = (payload) => ({
  type: GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES,
  payload: payload
})

export const getAdminManageClientSourceTypesSuccess = (payload) => ({
  type: GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_SUCCESS,
  payload: payload
})

export const getAdminManageClientSourceTypesError = (error) => ({
  type: GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_ERROR,
  error: error
})

export const getAdminManageClientSourceTypesByAccount = (payload) => ({
  type: GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT,
  payload: payload
})

export const getAdminSourceTypesByAccountSuccess = (payload) => ({
  type: GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_SUCCESS,
  payload: payload
})

export const getAdminSourceTypesByAccountError = (error) => ({
  type: GET_ADMIN_MANAGE_CLIENT_SOURCE_TYPES_BY_ACCOUNT_ERROR,
  error: error
})

export const getAdminManageClientMarketingGroups = () => ({
  type: GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS
})

export const getAdminMarketingGroupsSuccess = (payload) => ({
  type: GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_SUCCESS,
  payload: payload
})

export const getAdminMarketingGroupsError = (error) => ({
  type: GET_ADMIN_MANAGE_CLIENT_MARKETING_GROUPS_ERROR,
  error: error
})
